import { ShouldNotHappen } from 'utils';

import {
  CommentaireResponseDto,
  UserDto,
  UserDtoProfileEnum,
} from 'lib_api/lib/api/gen';

export function getUserLabel(user: UserDto): string | undefined {
  switch (user.profile) {
    case UserDtoProfileEnum.AUTORITE_FOURRIERE:
    case UserDtoProfileEnum.GARDIEN_FOURRIERE:
    case UserDtoProfileEnum.FORCE_DE_L_ORDRE:
    case UserDtoProfileEnum.ADMIN_FONCTIONNEL:
    case UserDtoProfileEnum.TRIBUNAL_JUDICIAIRE:
    case UserDtoProfileEnum.COUR_APPEL:
    case UserDtoProfileEnum.UNITE_OPERATIONNELLE:
    case UserDtoProfileEnum.NATIONAL_JUSTICE:
      return `${user.firstName || ''} ${user.lastName || ''}`.trim();
    case UserDtoProfileEnum.DSR_BLR:
    case UserDtoProfileEnum.CSU:
    case null:
      return undefined;
    default:
      throw new ShouldNotHappen(user.profile);
  }
}

export function getLibelleEntiteRattachement(
  commentaire: CommentaireResponseDto,
): string {
  return commentaire.libelleEntiteRattachement.trim();
}
